// removed by extract-text-webpack-plugin
module.exports = {"component":"_1gu6jxTmfK-vSVoZBOoqRH","modalContent":"_-Oq66Osv2ytE6V8Qo-GEQ","header":"ueacRZ_i91d2aDDygOOO8","title":"_2V5b7Qj0pTjEKEOvWy0j9e","tail":"_1JvLOf5Tv6O5ty0Vb0i_e9","item":"_2SGafGJy1phW2WNne6_Ffv","checkbox":"_3PRTKcp0zPYhvIpKtJtUz1","close":"VPDX3zUMzTZoiwplg-QJO","zhuan_a":"_17t8cFMJtxE6HdvcIyB94W","zhuan":"_3osuoutB00A6u_fG7SqFLE"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PrivilegeModal/PrivilegeModal.scss
 ** module id = 1014
 ** module chunks = 0
 **/